import { Navigate } from "react-router-dom";
import { useAppContext } from "../pages/context/AppContext.jsx";

function PrivateRoute({ children }) {
  const { token, logado, trialfim, assinaturafim } = useAppContext();

  const isAuthenticated = logado && !!token;

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const hoje = new Date();

  const trialFim = trialfim ? new Date(trialfim) : null;
  const assinaturaFim = assinaturafim ? new Date(assinaturafim) : null;

  const acessoLiberado =
    (trialFim && hoje <= trialFim) ||
    (assinaturaFim && hoje <= assinaturaFim);

  if (!acessoLiberado) {
    return <Navigate to="/assinatura" replace />;
  }

  return children;
}

export default PrivateRoute;